/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import React from 'react'

import { useMediaquery } from '../../hooks'
import { CtaButton } from '..'
import { Content, Heading, Kicker } from '../Typography'
import {
  btnMargin,
  headingContainer,
  headingContentContainer,
  sectionHeader,
} from './SectionHeader.module.css'

const SectionHeader = ({
  containerwidth,
  content,
  cta,
  ctaColumn,
  ctaExtraClassName,
  extraBtnClassName,
  extraClassName,
  extraContentClassName,
  extraDescriptionClassName,
  extraHeadingClassName,
  extraHeadingContainerClassName,
  extraKickerClassName,
  heading,
  heroHeader,
  iscarorusel,
  kicker,
  renderedContent,
  withCta,
  withParagraph,
}) => {
  const isDesktop = useMediaquery('(min-width: 768px)')
  const width = isDesktop
    ? containerwidth
      ? `${containerwidth}%`
      : 'container'
    : '100%'

  return (
    <div className={`${sectionHeader} ${extraClassName}`} style={{ width }}>
      <div className={`${headingContainer} ${extraHeadingContainerClassName}`}>
        {kicker && !iscarorusel && (
          <Kicker extraClassName={extraKickerClassName} gold>
            {kicker}
          </Kicker>
        )}
        {heroHeader && !iscarorusel && (
          <Heading extraClassName={extraHeadingClassName} heroHeader>
            {heroHeader}
          </Heading>
        )}
        {heading && (
          <Heading
            extraClassName={extraHeadingClassName}
            withParagraph={withParagraph}
          >
            {heading}
          </Heading>
        )}
        {withCta && cta && !ctaColumn && (
          <CtaButton
            className={btnMargin}
            extraClassName={ctaExtraClassName}
            {...cta}
          />
        )}
      </div>
      <div
        className={`${headingContentContainer} ${extraDescriptionClassName}`}
      >
        {content && <Content>{content}</Content>}
        {renderedContent && !iscarorusel && (
          <Content
            extraClassName={extraContentClassName}
            renderContent={renderedContent}
          />
        )}
        {withCta && cta && ctaColumn && (
          <CtaButton
            {...cta}
            className={extraBtnClassName}
            extraClassName={ctaExtraClassName}
          />
        )}
      </div>
    </div>
  )
}

export default SectionHeader
